import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { SummaryTitle } from './common/summary_title';
import { SummarySubTitle } from './common/summary_sub_title';
import { ReviewAndEditYourDetails } from './common/review_and_edit_your_details';

import { ContainerWrapper } from '../container_wrapper';

const useStyles = createUseStyles({
    title: (theme) => ({
        fontWeight: theme.fontWeight.bold,
        fontSize: theme.fontSize['3xl'],
        color: theme.colors.primary800,
        marginBottom: theme.spacing[8]
    }),
    subTitle: (theme) => ({
        fontSize: theme.fontSize.xl,
        marginBottom: theme.spacing[8],
        maxWidth: '70%'
    })
});

const PolicySummarySm = ({ padding }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles(theme);

    return (
        <ContainerWrapper padding={padding} className={classNames('test-policySummary-sm')}>
            <SummaryTitle className={classes.title} />
            <SummarySubTitle className={classes.subTitle} />
            <ReviewAndEditYourDetails />
        </ContainerWrapper>
    );
};

PolicySummarySm.propTypes = {
    padding: PropTypes.array
};

export { PolicySummarySm };
